import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'

export const useRouteTitle = (fallbackTitle: string, syncDocumentTitle = true) => {
  const route = useRoute()
  const routeTitle = computed(() => {
    return typeof route.meta?.title === 'string' && route.meta.title.trim()
      ? route.meta.title
      : fallbackTitle
  })

  if (syncDocumentTitle) {
    watch(routeTitle, (title) => {
      document.title = title
    }, { immediate: true })
  }

  return routeTitle
}
